export default class CancelRejectPaymentOrderRequest{
    reason: string = '';
}
